export const documentation = {
  junior: [
    { name: 'Product Design Process Guide', url: '/docs/product-design-process', type: 'process' },
    { name: 'Design Thinking Framework', url: '/docs/design-thinking', type: 'methodology' },
    { name: 'User Research for Designers', url: '/docs/user-research-design', type: 'research' },
    { name: 'Prototyping Best Practices', url: '/docs/prototyping-practices', type: 'prototyping' },
    { name: 'Design Handoff Guidelines', url: '/docs/design-handoff', type: 'handoff' }
  ],
  mid: [
    { name: 'Advanced Product Design Strategy', url: '/docs/product-design-strategy', type: 'strategy' },
    { name: 'Design Systems for Product Design', url: '/docs/design-systems-product', type: 'design-systems' },
    { name: 'Cross-functional Collaboration', url: '/docs/cross-functional-design', type: 'collaboration' },
    { name: 'Product Analytics for Designers', url: '/docs/product-analytics-design', type: 'analytics' },
    { name: 'Advanced Prototyping Techniques', url: '/docs/advanced-prototyping', type: 'prototyping' }
  ],
  senior: [
    { name: 'Design Leadership Framework', url: '/docs/design-leadership', type: 'leadership' },
    { name: 'Product Design Operations', url: '/docs/design-operations', type: 'operations' },
    { name: 'Design Strategy & Vision', url: '/docs/design-strategy-vision', type: 'strategy' },
    { name: 'Scaling Design Teams', url: '/docs/scaling-design-teams', type: 'scaling' },
    { name: 'Design Impact Measurement', url: '/docs/design-impact-measurement', type: 'impact' }
  ]
};
